module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-icons-03-18ff392a2afbfba41a9175f47dab4296.png";